import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Box, Typography } from "@material-ui/core";
import { KPICard, NoDataFound } from "../../../../../Components";
import { TransactionCard } from "../TransactionCard";
import { formatNumberCompact } from "../../../../../Helper";
import { useTranslate } from "../../../../../Hooks";

import useStyles from "./styles";

import { AEDIcon } from "../../../../../assets/icons";
import { GetAfterSalesTransactionByContactId } from "../../../../../Services/AfterSalesServices/AfterSalesServices";
import TransactionSkeletonCard from "../SkeletonLoaders/TransactionSkeletonCard";

function TransactionPanel({ loading, tranActionDetails }) {
  const styles = useStyles();
  const { translate } = useTranslate("AfterSalesClientProfileView");

  return (
    <Box className={styles.panelContainer}>
      <Box display={"flex"} gridGap={"24px"}>
        <KPICard loading={loading}>
          <KPICard.Title>
            <Typography className={styles.summeryTitle} variant="body2">
              {translate("total-units-title")}
            </Typography>
          </KPICard.Title>
          <KPICard.Content>
            <Typography
              variant="body2"
              className={styles.summeryText}
              component="p"
            >
              {typeof tranActionDetails?.result[0]?.portfolioOverview
                ?.ownedUnits === "number"
                ? formatNumberCompact(tranActionDetails?.result?.length)
                : "N/A"}
            </Typography>
          </KPICard.Content>
        </KPICard>
        <KPICard loading={loading}>
          <KPICard.Title>
            <Typography className={styles.summeryTitle} variant="body2">
              {translate("transaction-value")}
            </Typography>
          </KPICard.Title>
          <KPICard.Content>
            <Typography
              className={styles.summeryText}
              variant="body2"
              component="p"
            >
              {typeof tranActionDetails?.result[0]?.portfolioOverview
                ?.totalTransactionValue === "number"
                ? formatNumberCompact(
                    tranActionDetails?.result[0]?.portfolioOverview
                      ?.totalTransactionValue || "N/A"
                  )
                : "N/A"}
              {typeof tranActionDetails?.result[0]?.portfolioOverview
                ?.totalTransactionValue === "number" && (
                <AEDIcon className={styles.aedIcon} width="20" height="20" />
              )}
            </Typography>
          </KPICard.Content>
        </KPICard>
        <KPICard loading={loading}>
          <KPICard.Title>
            <Typography className={styles.summeryTitle} variant="body2">
              {translate("portfolio-value")}
            </Typography>
          </KPICard.Title>
          <KPICard.Content>
            <Typography
              variant="body2"
              className={styles.summeryText}
              component="p"
            >
              {typeof tranActionDetails?.result[0]?.portfolioOverview
                ?.portfolioValue === "number"
                ? formatNumberCompact(
                    tranActionDetails?.result[0]?.portfolioOverview
                      ?.portfolioValue
                  )
                : "N/A"}
              {typeof tranActionDetails?.result[0]?.portfolioOverview
                ?.portfolioValue === "number" && (
                <AEDIcon className={styles.aedIcon} width="20" height="20" />
              )}
            </Typography>
          </KPICard.Content>
        </KPICard>
        <KPICard loading={loading}>
          <KPICard.Title>
            <Typography className={styles.summeryTitle} variant="body2">
              {translate("average-roi")}
            </Typography>
          </KPICard.Title>
          <KPICard.Content>
            <Typography
              variant="body2"
              className={clsx(styles.roi, {
                [styles.success]:
                  tranActionDetails?.result[0]?.portfolioOverview?.averageROI >
                  0,
                [styles.error]:
                  tranActionDetails?.result[0]?.portfolioOverview?.averageROI <
                  0,
              })}
              component="p"
            >
              {typeof tranActionDetails?.result[0]?.portfolioOverview
                ?.averageROI === "number"
                ? formatNumberCompact(
                    tranActionDetails?.result[0]?.portfolioOverview?.averageROI
                  ) + "%"
                : "N/A"}
            </Typography>
          </KPICard.Content>
        </KPICard>
      </Box>
      <Box className={styles.transactionList}>
        {!loading &&
          tranActionDetails?.result?.map((item) => (
            <TransactionCard key={item.unitTransactionId} transaction={item} />
          ))}
        {loading &&
          Array.from({ length: 10 }).map((_, index) => (
            <TransactionSkeletonCard key={index} />
          ))}
        {!loading && tranActionDetails?.result?.length === 0 && (
          <NoDataFound title={translate("no-transactions")} subTitle="" />
        )}
      </Box>
    </Box>
  );
}

export default TransactionPanel;
